<template>
  <main id="settings-general" class="site-main">
    <div class="section-menu">
      <ul class="show-for-large">
        <li class="section-menu__item active" @click="showSection($event, 'general')">General</li>
        <li class="section-menu__item" @click="showSection($event, 'commissions')">Commissions</li>
        <li class="section-menu__item" @click="showSection($event, 'paypal')" v-if="$store.state.shop && $store.state.shop.can_use_paypal">PayPal</li>
        <li class="section-menu__item" @click="showSection($event, 'portal')">Vendor Portal</li>
        <!--        <li class="section-menu__item" @click="showSection($event, 'paypal')">Languages</li>-->
      </ul>

      <div class="select-field hide-for-large">
        <select id="section-menu" @change="showSectionSelect($event)">
          <option value="general">General</option>
          <option value="commissions">Commissions</option>
          <option value="paypal">PayPal</option>
          <option value="portal">Vendor Portal</option>
          <!--          <option value="paypal">Languages</option>-->
        </select>

        <i class="fas fa-sort"></i>
      </div>
    </div>

    <div class="grid-x grid-padding-x">
      <div class="cell">
        <div class="section-area">
          <div class="grid-container grid-container--small">
            <div id="general" class="section-content" style="display: block;">
              <div class="panel text-left">
                <div :class="['loading-area', settingsSaving ? 'loading' : '']">
                  <div :class="['loading-area__content', settingsSaving ? 'loading' : '']">
                    <div class="panel__header">
                      <h3 class="panel__title">General Settings</h3>
                    </div>

                    <div class="form-field">
                      <div class="grid-x grid-padding-x">
                        <div class="cell large-4">
                          <label>App Theme</label>
                        </div>

                        <div class="cell auto">
                          <label
                            :class="['radio-choice', settings && settings.theme === 'light' ? 'active' : '']"
                            for="theme-light" style="background: #fff; color: #333;"
                            @click="theme('light')">Light
                            <input id="theme-light" class="hidden" type="radio" name="theme"
                                   value="light">
                          </label>

                          <label
                            :class="['radio-choice', settings && settings.theme === 'dark' ? 'active' : '']"
                            for="theme-dark" style="background: #333; color: #fff;"
                            @click="theme('dark')">Dark
                            <input id="theme-dark" class="hidden" type="radio" name="theme"
                                   value="dark" checked="checked">
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="form-field">
                      <div class="grid-x grid-padding-x">
                        <div class="cell large-4">
                          <label for="currency">Currency</label>
                        </div>

                        <div class="cell auto">
                          <div class="select-field" style="display: inline-block; width: auto;">
                            <select id="currency" name="currency" @change="changeCurrency($event)">
                              <option v-for="(currency, key) in currencies" :key="key"
                                      :value="currency.value"
                                      :selected="metas && metas.currency.meta_value === currency.value">
                                {{ currency.name }}
                              </option>
                            </select>

                            <i class="fas fa-sort"></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-field">
                      <div class="grid-x grid-padding-x">
                        <div class="cell large-4">
                          <label>Vendor Order Notifications
                            <span data-tooltip title="Send Vendor email notifications for new orders">
                            <i class="fas fa-question-circle"></i></span>
                          </label>
                        </div>

                        <div class="cell auto">
                          <checkbox @check="enableOrderNotifications"
                                    :active="metas.vendor_enable_order_notifications ? metas.vendor_enable_order_notifications.meta_value : false"></checkbox>
                        </div>
                      </div>
                    </div>

                    <div class="form-field">
                      <div class="grid-x grid-padding-x">
                        <div class="cell large-4">
                          <label>CC Vendor Order Notifications to Shop Email
                            <span data-tooltip
                            title="CC shop email for vendor new orders notifications.">
                            <i class="fas fa-question-circle"></i></span>
                          </label>
                        </div>

                        <div class="cell auto">
                          <checkbox @check="enableOrderNotificationsCC"
                                    :active="metas.vendor_enable_order_notifications_cc ? metas.vendor_enable_order_notifications_cc.meta_value : false"></checkbox>
                        </div>
                      </div>
                    </div>

                    <div class="form-field">
                      <div class="grid-x grid-padding-x">
                        <div class="cell large-4">
                          <label>Vendor Payout Notifications
                            <span data-tooltip title="Send Vendor email notifications when a payout is created">
                            <i class="fas fa-question-circle"></i></span>
                          </label>
                        </div>

                        <div class="cell auto">
                          <checkbox @check="enablePayoutNotifications"
                                    :active="metas.vendor_enable_payout_notifications ? metas.vendor_enable_payout_notifications.meta_value : true"></checkbox>
                        </div>
                      </div>
                    </div>

                    <div class="form-field">
                      <div class="grid-x grid-padding-x">
                        <div class="cell large-4">
                          <label>Disable Account Approval Emails
                            <span data-tooltip title="Disable vendors from receiving an email when their new account is approved">
                            <i class="fas fa-question-circle"></i></span>
                          </label>
                        </div>

                        <div class="cell auto">
                          <checkbox @check="disableAccountApproval"
                                    :active="metas.vendor_disable_approval_email ? metas.vendor_disable_approval_email.meta_value : false"></checkbox>
                        </div>
                      </div>
                    </div>

                    <!--<div class="form-field">
                      <div class="grid-x grid-padding-x">
                        <div class="cell large-4">
                          <label>Visible Fields to Vendors
                            <span data-tooltip tabindex="4" title="The selected fields will be visible
                            for your vendors to see within their dashboard.">
                              <i class="fas fa-question-circle"></i></span>
                          </label>
                        </div>

                        <div class="cell auto">
                          <div class="grid-x align-middle">
                            <div class="cell shrink">
                              <div
                                class="checkbox-choice{% if visible_field.active %} active{% endif %}">
                                <input type="checkbox" name="vendor-visible-fields[]" value="">
                              </div>
                            </div>

                            <div class="cell auto">
                              <div style="margin-left: 10px;"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>-->

                    <div class="text-success-color text-right" v-if="success">Settings have been
                      saved.</div>

                    <div class="text-alert-color text-right" v-if="error">There
                      was an error saving. Please try again later.</div>

                    <div class="panel__footer text-right">
                      <button @click="save">Save</button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="panel">
                <div class="panel__header">
                  <h3 class="panel__title">Re-syncing Your Data</h3>
                </div>

                <p>Your data will stay up to date automatically, but if you find
                  that the data is not correct the you can re-sync with Shopify
                  to force an update.</p>
                <button @click="startDataSync">Sync Data</button>
              </div>
            </div>

            <div id="commissions" class="section-content">
              <commissions></commissions>
            </div>

            <div id="paypal" class="section-content">
              <paypal></paypal>
            </div>

            <div id="portal" class="section-content">
              <portal></portal>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import client from '@/mixins/client'
import currencies from '@/assets/data/currencies.json'
import commissions from '@/pages/settings/commissions'
import paypal from '@/pages/settings/paypal'
import portal from '@/pages/settings/portal'
import checkbox from '@/globals/checkbox'

export default {
  name: 'settingsGeneral',
  mixins: [client],
  components: {
    commissions,
    paypal,
    checkbox,
    portal
  },
  data: function () {
    return {
      error: false,
      success: false,
      currencies: currencies,
      settingsSaving: false
    }
  },
  methods: {
    async saveSettings () {
      await this.request('put', '/settings/settings/' + this.settings.id + '/retrieve-update/', {
        theme: this.settings.theme
      })

      await this.$store.dispatch('updateMeta', this.metas.vendor_disable_approval_email)
      await this.$store.dispatch('updateMeta', this.metas.vendor_enable_order_notifications)
      await this.$store.dispatch('updateMeta', this.metas.vendor_enable_order_notifications_cc)
      await this.$store.dispatch('updateMeta', this.metas.vendor_enable_payout_notifications)
      await this.$store.dispatch('updateMeta', this.metas.currency)

      this.settingsSaving = false
      this.success = true
    },
    save () {
      this.settingsSaving = true

      this.saveSettings()
    },
    theme (theme) {
      this.settings.theme = theme

      this.request('put', '/settings/settings/' + this.settings.id + '/retrieve-update/', {
        theme: this.settings.theme
      })

      let body = document.getElementsByTagName('body')[0]

      if (theme === 'light') {
        body.classList.add('light-theme')
      } else {
        body.classList.remove('light-theme')
      }
    },
    disableAccountApproval () {
      this.metas.vendor_disable_approval_email.meta_value = !this.metas.vendor_disable_approval_email.meta_value
    },
    enableOrderNotifications () {
      this.metas.vendor_enable_order_notifications.meta_value = !this.metas.vendor_enable_order_notifications.meta_value
    },
    enableOrderNotificationsCC () {
      this.metas.vendor_enable_order_notifications_cc.meta_value = !this.metas.vendor_enable_order_notifications_cc.meta_value
    },
    enablePayoutNotifications () {
      this.metas.vendor_enable_payout_notifications.meta_value = !this.metas.vendor_enable_payout_notifications.meta_value
    },
    changeCurrency (e) {
      this.metas.currency.meta_value = e.target.value
    },
    showSection (e, section) {
      let activeItems = document.getElementsByClassName('section-menu__item')

      for (let i = 0; i < activeItems.length; i++) {
        activeItems[i].className = 'section-menu__item'
      }

      let sections = document.getElementsByClassName('section-content')

      for (let i = 0; i < sections.length; i++) {
        sections[i].style.display = 'none'
      }

      document.getElementById(section).style.display = 'block'
      e.target.className = 'section-menu__item active'
    },
    showSectionSelect (e) {
      let sections = document.getElementsByClassName('section-content')

      for (let i = 0; i < sections.length; i++) {
        sections[i].style.display = 'none'
      }

      document.getElementById(e.target.value).style.display = 'block'
    },
    startDataSync () {
      this.$store.state.settings.sync_active = true

      this.request('get', '/shop-sync/', {
        domain: this.$store.state.shop.myshopify_domain,
        app_slug: 'vendor-consignment'
      }).then(response => {
        let checkProgress = setInterval(() => {
          this.request('get', '/sync-progress/', {
            domain: this.$store.state.shop.myshopify_domain
          }).then(response => {
            let label = document.getElementById('progress-bar-label')
            let bar = document.getElementById('progress-bar-progress')

            if (response.description != null) {
              if (response.description.length > 0) {
                label.textContent = response.description + '...'
              }

              bar.style.width = response.progress + '%'
            } else {
              label.textContent = 'Syncing...'
            }

            if (!response.active) {
              this.$store.state.settings.sync_active = false
              clearInterval(checkProgress)

              label.textContent = 'Syncing...'
              bar.style.width = 0
            }
          })
        }, 3000)
      })
    }
  },
  computed: {
    settings () {
      return this.$store.state.settings
    },
    metas () {
      return this.$store.state.metas
    }
  },
  mounted () {
    let body = document.getElementsByTagName('body')[0]

    body.classList.add('section-page')
  },
  beforeDestroy () {
    let body = document.getElementsByTagName('body')[0]

    body.classList.remove('section-page')
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';

</style>



// WEBPACK FOOTER //
// src/pages/settings/general.vue